import { render, staticRenderFns } from "./sound-elem.vue?vue&type=template&id=e7335802&scoped=true"
import script from "./sound-elem.vue?vue&type=script&lang=js"
export * from "./sound-elem.vue?vue&type=script&lang=js"
import style0 from "./sound-elem.vue?vue&type=style&index=0&id=e7335802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7335802",
  null
  
)

export default component.exports